<template>
  <div class="order-info-container">
    <!-- 下单信息 -->
    <div class="order-info margin-bottom_15">
      <div class="text1">下单信息</div>
      <div class="flex info-row">
        <div class="text2">亚马逊仓库编码：<span class="text3">{{ data.storeCode }}</span></div>
        <div class="text2">邮政编码：<span class="text3">{{ data.destZipCode }}</span></div>
      </div>
      <div class="address-row text3">
        <span>{{ data.destCityNameEn }}, {{ data.destProvinceNameEn }}, {{ data.destCountryNameEn }}</span>
      </div>
    </div>
    <!-- 发货信息 -->
    <el-form ref="formData" class="shipping-info" :model="ruleForm" :rules="rules">
      <div class="text1">发货信息</div>
      <div class="delivery-method">
        <button
          :class="{'delivery-method-active': ruleForm.deliveryType == 1}"
          @click.prevent="selectDelivery(1)"
        >自送到仓</button>
        <button
          :class="{'delivery-method-active': ruleForm.deliveryType == 2}"
          @click.prevent="selectDelivery(2)"
        >上门取件</button>
      </div>
      <div class="flex warehouse-details">
        <el-form-item :label="deliveryName()" prop="goodsWarehouse">
          <el-select v-model="ruleForm.goodsWarehouse" size="mini" @change="warehouseChange">
            <el-option
              v-for="(item,index) in warehouseList"
              :key="index"
              :value="item.id"
              :label="item.wareName"
            />
          </el-select>
        </el-form-item>
        <div class="warehouse-details_info">
          <div class="text2">仓库地址：<span class="text3">{{ selectWarehouse.wareAddress }}</span></div>
          <div class="flex margin-top_10">
            <div class="text2">联系人：<span class="text3">{{ selectWarehouse.personCharge }}</span></div>
            <div class="text2 margin-left_20">联系电话：<span class="text3">{{ selectWarehouse.personPhone }}</span></div>
          </div>
        </div>
      </div>
      <div v-if="ruleForm.deliveryType == 2" class="tip-row">下单成功后，请联系平台客服预约取件。</div>
      <div class="next-step">
        <button class="next-step-btn" @click.prevent="nextStep(1)">下一步</button>
      </div>
    </el-form>
  </div>
</template>
<script>
import request from '@/utils/request'
import { getCookie } from '@/utils/cookiejs'
export default {
  name: 'Index',
  components: {

  },
  props: {

  },
  data() {
    return {
      data: {},
      ruleForm: {
        goodsWarehouse: '',
        deliveryType: 1
      },
      rules: {
        goodsWarehouse: [
          { required: true, message: '请选择仓库', trigger: 'blur' }
        ]
      },
      selectWarehouse: {},
      warehouseList: []
    }
  },
  created() {
    // 实例被创建之后执行代码
  },
  mounted() {

  },
  methods: {
    init(data) {
      this.data = data
	  if (data.deliveryType) {
		  this.ruleForm.deliveryType = data.deliveryType
	  }
      this.getGoodsWarehouse(data.warehouseId)
    },
    selectDelivery(index) {
      this.ruleForm.deliveryType = index
    },
    getGoodsWarehouse(warehouseId) {
      request({
        url: `/api/wms/warehouse/GetGoodsWarehouseList?warehouseId=` + warehouseId,
        method: 'get',
        headers: {
          'Authorization': getCookie('token')
        }
      }).then(res => {
        this.warehouseList = res.data
        if (this.data.goodsWarehouse) {
          this.ruleForm.goodsWarehouse = this.data.goodsWarehouse
          this.warehouseChange(this.ruleForm.goodsWarehouse)
        }
      })
    },
    warehouseChange(val) {
      this.selectWarehouse = this.warehouseList.filter(item => item.id == val)[0]
    },
    deliveryName() {
      switch (this.ruleForm.deliveryType) {
        case 1:
          return '交货仓库'
        case 2:
          return '送达仓库'
      }
    },
    nextStep(index) {
      this.$nextTick(() => {
        this.$refs['formData'].validate((val) => {
          if (val) {
            this.$parent.nextStep(index)
          }
        })
      })
    },
    validateForm() {
      return new Promise((resolve) => {
        this.$refs.formData.validate((valid) => {
          if (valid) {
            // 验证通过，触发自定义事件并传递表单数据
            this.$emit('submitForm', this.ruleForm) // 将表单数据作为参数传递
            resolve(true)
          } else {
            resolve(false)
          }
        })
      })
    }
  }
}
</script>
<style scoped lang='scss'>
.order-info-container {
    width: 100%;
    background-color: #fff;
    border-radius: 8px;
    box-sizing: border-box;
    text-align: left;
    padding: 20px;

    .order-info{

        .info-row{
            width: 400px;
            margin: 15px 0;
            display: flex;
            justify-content: space-between;
        }

    }

    .shipping-info{
        border-top: 1px solid #E5E5E5;
        padding-top: 15px;
        .delivery-method{
            margin: 15px 0;
            display: flex;
			border-radius: 8px;
			background: #fff;
			overflow: hidden;
			border: 1px solid #e0e0e0;
			width: fit-content;
            button{
				outline: none;
				border: none;
				width: 80px;
				height: 32px;
				background: #fff;
				box-sizing: border-box;
				transition: all 0.3s;

				&:hover {
					cursor: pointer;

					span {
						font-weight: 600;
					}
				}

				span {
					display: inline-block;
					font-family: PingFangSC, PingFang SC;
					font-weight: 400;
					font-size: 13px;
					color: #333333;
					line-height: 24px;
					text-align: center;
					font-style: normal;
				}
			}
            .delivery-method-active {
				background: #3370FF;
				color: #fff;
			}
        }

        .warehouse-label{
            margin: 15px 0;
            display: flex;
            align-items: center;
        }
        .warehouse-details{
            width: 100%;
            align-items: center;
            .warehouse-details_info{
                width: 70%;
                margin-left: 50px;
            }
        }

        .tip-row{
            color: #3370FF;
            font-size: 14px;
        }

        .next-step{
            width: 100%;
            text-align: right;
            margin-top: 20px;
            .next-step-btn{
                width: 140px;
                height: 50px;
                font-size: 18px;
                background-color: #007BFF;
                color: white;
                border: none;
                border-radius: 3px;
                cursor: pointer;
            }
        }
    }

    .text1{
        font-size: 14px;
        font-weight: bold;
        color: #333333;
    }

    .text2{
        font-size: 14px;
        font-weight: 400;
        color: #777777;
    }

    .text3{
        font-size: 14px;
        font-weight: 400;
        color: #333333;
    }
}
</style>
